import React from 'react';
import { Menu } from 'antd';
import { useLocation } from 'react-router-dom';
import { menuItems } from '../../routes'; // Import from centralized routes file

const SidebarMenu = () => {
  const location = useLocation();

  // Get keys of all parent menus to open them by default
  const allParentKeys = menuItems
    .filter(item => item.children)
    .map(item => item.key);

  return (
    <Menu
      theme="dark"
      mode="inline"
      // Set selected key based on current URL
      selectedKeys={[location.pathname]}
      // Set all parent menus to be open by default
      defaultOpenKeys={allParentKeys}
      items={menuItems}
    />
  );
};

export default SidebarMenu;